export enum QuickstartOperation {
    Existing = "existing",
    Data = "precision",
    Typeform = "typeform"
}
